namespace Nobox {
    @Serenity.Decorators.registerFormatter()
    export class StatusConversationFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            var status = ctx.value;
            if (status == 1) {
                return `<div class="lkbadge lkbadge-danger lkbadge-dim">Unassigned</div>`;
            } else if (status == 2) {
                return `<div class="lkbadge lkbadge-primary lkbadge-dim">Assigned</div>`;
            } else if (status == 3) {
                return `<div class="lkbadge lkbadge-success lkbadge-dim">Resolved</div>`;
            } else if (status == 4) {
                return `<div class="lkbadge lkbadge-secondary lkbadge-dim">Archived</div>`;
            }
        }
    }
}